import { localDB } from "src/app/shared/helpers/localStorage";

export function moduleActive(modulePrefix: string): boolean {
  const dataModule = JSON.parse(localDB.getItem('Active-Modules')).data;
  return dataModule?.some((mod: any) => mod.sPrefijo === modulePrefix && mod.nEstado === 1);
}
